import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => createStyles({
  link: {
    color: '#3e3cba',
  }
}));

export default useStyles;